import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("login");
  const [showPartyPick, setShowPartyPick] = useState(false);

  const loadMe = async () => {
    const token = localStorage.getItem("ca_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch (e) {
      localStorage.removeItem("ca_token");
    }
    setLoading(false);
  };

  useEffect(() => {
    loadMe();
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("ca_token", token);
    setUser(userData);
    setAuthOpen(false);
  };

  const logout = () => {
    localStorage.removeItem("ca_token");
    setUser(null);
  };

  const openAuth = (mode = "login") => {
    setAuthMode(mode);
    setAuthOpen(true);
  };

  const isAdmin = user && (user.roles || []).some((r) => ["super_admin", "admin", "moderator", "resolution_coordinator"].includes(r));

  return (
    <AuthContext.Provider
      value={{ user, setUser, loading, login, logout, authOpen, setAuthOpen, authMode, openAuth, isAdmin, refresh: loadMe, showPartyPick, setShowPartyPick }}
    >
      {children}
    </AuthContext.Provider>
  );
};
